import React from "react";

import AnalyticsTracking from "Utils/AnalyticsTracking";
import { BasicLoading } from "ZeroRuby";

import { Body1, Body2 } from "Cobalt/BodyText";
import { LinkButton } from "Cobalt/Button";
import Header from "Cobalt/Header";
import { Row, Col } from "Common/Grid";
import { Ul, Li, Div } from "Common/HTML";
import Icon from "Common/Icon";

import { useGetCallToActionDataQuery } from "./api";

const CallToAction = () => {
  const { data, isLoading } = useGetCallToActionDataQuery();
  if (isLoading) return <BasicLoading />;
  const partnerName = data.partner_name;
  return (
    <div className="w-full px-5">
      <Row>
        <Col my={5} md={8} mdOffset={2} lg={6} lgOffset={3}>
          <Header level={4}>Login to {partnerName} Payroll to Continue</Header>
          <Body1>
            {/* Thanks for your interest in SimplyInsured! Contact your {partnerName} sales representative to sign up for {partnerName} Payroll */}
            Contact your {partnerName} sales representative to sign up for {partnerName} Payroll and offer health insurance.
          </Body1>
        </Col>
      </Row>
      <Row style={{ backgroundColor: "#f5f5f5" }}>
        <Col my={6} md={8} mdOffset={2} lg={6} lgOffset={3}>
          <Header level={6} mb={3}>
            Seamless Integration between {partnerName} and SimplyInsured
          </Header>
          <Ul>
            <Li>Automated payroll deductions</Li>
            <Li>Online open enrollment and one-click renewal</Li>
            <Li>Automated employee enrollments and terminations</Li>
            <Li>Medical, Dental, Vision, Life, AD&D, Disability, and more</Li>
            <Li>Free to use for {partnerName} Payroll customers</Li>
          </Ul>
        </Col>
      </Row>
      <Row>
        <Col my={6} md={8} mdOffset={2} lg={6} lgOffset={3}>
          <Header level={6}>Talk to a SimplyInsured Licensed Agent</Header>

          <Body2 mb={2}>Schedule a consultation with a licensed agent to discuss your quotes and learn more about SimplyInsured.</Body2>
          <LinkButton
            size="medium"
            my={2}
            href="https://calendly.com/simplyinsured-consultation/simplyinsured-health-insurance-consultation"
            target="_blank"
            onClick={() => {
              AnalyticsTracking.trackEvent("presales_lead_schedule_consultation_clicked");
            }}
          >
            Schedule Consultation
            <Icon icon="external-link-alt" />
          </LinkButton>
        </Col>
      </Row>
      <Row style={{ backgroundColor: "#f5f5f5" }}>
        <Col mt={6} md={8} mdOffset={2} lg={6} lgOffset={3}>
          <Header level={6} mb={3}>
            Preview the SimplyInsured Platform
          </Header>
        </Col>
        <Col mb={6} md={8} mdOffset={2} lg={6} lgOffset={3}>
          <Body2 mb={2}>Manage benefits with the SimplyInsured Company Dashboard</Body2>
          <Div className="aspect-video">
            <iframe title="vimeo-player" src="https://player.vimeo.com/video/1068289523" allowfullscreen />
          </Div>
        </Col>
        <Col mb={6} md={8} mdOffset={2} lg={6} lgOffset={3}>
          <Body2 mb={2}>Apply for insurance online in minutes through {partnerName} Payroll</Body2>
          {partnerName === "Toast" && (
            <Div className="aspect-video">
              <iframe title="vimeo-player" src="https://player.vimeo.com/video/1061061554" allowfullscreen />
            </Div>
          )}
          {partnerName !== "Toast" && (
            <Div className="aspect-video">
              <iframe title="vimeo-player" src="https://player.vimeo.com/video/1068289867" allowfullscreen />
            </Div>
          )}
        </Col>
      </Row>
      <Row>
        <Col my={6} md={8} mdOffset={2} lg={6} lgOffset={3}>
          <Header level={6} mb={3}>
            Want to keep your existing plans?
          </Header>
          <Body2 mb={2}>Switch your brokerage to SimplyInsured to get all the benefits of the payroll integration with your existing insurance plans.</Body2>
          <Ul>
            <Li>Deductions synced to your payroll</Li>
            <Li>Automatic employee enrollments and terminations</Li>
            <Li>Access to SimplyInsured’s team of experts and support</Li>
            <Li>No additional cost or fees</Li>
          </Ul>
        </Col>
      </Row>
    </div>
  );
};

export default CallToAction;
